// extracted by css-extract-rspack-plugin
var _1 = "LoadingIndicator-module__dot--rgEqK";
var _2 = "LoadingIndicator-module__inline--dmsoO";
var _3 = "LoadingIndicator-module__large--faAEA";
var _4 = "LoadingIndicator-module__loader--pQOBS";
var _5 = "LoadingIndicator-module__medium--kEyHt";
var _6 = "LoadingIndicator-module__pulse--WmMm1";
var _7 = "LoadingIndicator-module__small--Ie9r1";
export { _1 as "dot", _2 as "inline", _3 as "large", _4 as "loader", _5 as "medium", _6 as "pulse", _7 as "small" }
